import { Component, ElementRef, inject, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@coin/shared/auth/data-access';
import { CmsContentItemContent, CmsContentPageSettings, CmsItem } from '@coin/shared/cms/util';
import { CmsContentPagesService } from '@coin/shared/cms/data-access';
import { MatTabGroup, MatTab, MatTabLabel, MatTabContent } from '@angular/material/tabs';
import { NgClass, NgStyle } from '@angular/common';
import { AllCmsNewsItemsComponent } from '../all-cms-news-items/all-cms-news-items.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabGroup, MatTab, MatTabLabel, NgClass, MatTabContent, NgStyle, AllCmsNewsItemsComponent]
})
export class PreviewComponent implements OnInit {
  authService = inject(AuthService);
  private readonly cmsContentPagesService = inject(CmsContentPagesService);

  @ViewChild('mainSize', { static: false }) mainSize: ElementRef<HTMLDivElement>;

  @Input() item: CmsContentItemContent;
  @Input() maxHeight = 380;
  @Input() heightModified = false;
  @Input() frame = false;
  @Input() isEquityPage = false;
  @Input() overviewUpdate = true;
  @Input() settings: CmsContentPageSettings;
  @Input() highlightItem: CmsItem;
  @Input() germanyRowType: string;
  public selectedTab = 0;
  public zoomValues: Record<string, number> = {};
  public highlightId: string;

  ngOnInit(): void {
    setTimeout(() => {
      this.changeOfTab(2);
      this.changeOfTab(1);
      this.changeOfTab(0);
    }, 200);
  }

  public changeOfTab(index: number): void {
    this.selectedTab = index;
    setTimeout(() => {
      switch (index) {
        case 0:
          this.getZoom('desktop', 1900);
          break;
        case 1:
          this.getZoom('mobile', 540);
          break;
        case 2:
          this.getZoom('laptop', 1150);
          break;
      }
    }, 600);
  }

  public getZoom(type: string, width: number): void {
    let elemWidth = 0;
    if (type && this.mainSize && this.mainSize.nativeElement) {
      elemWidth = this.mainSize.nativeElement.offsetWidth;
      if (elemWidth > 0) {
        this.zoomValues[type] = elemWidth / width;
      } else {
        setTimeout(() => {
          this.getZoom(type, width);
        }, 1200);
      }
    }
  }

  public onItemClicked(item: CmsItem): void {
    this.cmsContentPagesService.highlightInEditMode?.scrollAndExpandItem(item.id);
  }

  public chapterOverviewClicked(): void {
    this.cmsContentPagesService.highlightInEditMode?.scrollAndExpandItem('chapter-overview');
  }
}
